export const Alarm = {
  variable:
    '$keyword: String, $scope: Scope, $duration:Duration!, $paging: Pagination!',
  query: `
    getAlarm(keyword: $keyword, scope: $scope, duration: $duration, paging: $paging) {
      items: msgs {
        key: id
        message
        startTime
        scope
      }
      total
    }`
};

export const AlarmService = {
  variable:
    '$duration: Duration!, $serviceId: ID!,  $query: String!, $pagination: Pagination!,$filterCondition: FilterCondition!',
  query: `
  AlarmsOut:getAlarmForService(duration: $duration,serviceId: $serviceId, query:$query,paging: $pagination,filterCondition: $filterCondition) {
    msgs {
      alarmMessage
      docCount
      latest
    } 
    total
  }`
};

export const NotificationResult = {
  variable: '$serviceId: ID!',
  query: `
  NotificationResult: getNotificationChannels(serviceId: $serviceId) {
    serviceId,
    email,
    webhook,
    slack
  }`
};

export const PostNotificationResult = {
  variable: '$notificationRequest: NotificationRequest!',
  query: `
  alarmCreationResult: createNotificationChannelForService(notificationRequest: $notificationRequest) {
    id: id
    errorReason: errorReason
  }`
};

export const ConfiguredAlerts = {
  variable: '$serviceId: ID!, $query: String!, $paging: Pagination!',
  query: `
  AlarmResult: getAlarmConfig(serviceId: $serviceId, query: $query, paging: $paging) {
    config {
      metricsName,
      threshold,
      count,
      period,
      silencePeriod,
      op,
      id,
      createdBy,
      modified,
      modifiedBy,
      lastUpdate
    }
    total
  }`
};

export const PostAlarm = {
  variable: '$alarmRequest: AlarmRequest!',
  query: `
  alarmCreationResult: alarmForService(alarmRequest: $alarmRequest) {
    id: id
    errorReason: errorReason
  }`
};
